/*
 * @description: 通用操作定义
 * @author: xuy
 * @since: 2020-03-13 08:48:29
 * @version: 1.0
 */
import {setToken, setAuthed, removeAuthed, removeToken} from './utils/auth'
import handler from '@/config/handler'
import store from '@/framework/store'
import router from '@/framework/router'
import appConfig from '@/config/app-config'
import { Message } from 'element-ui'

export default {
  /**
   * 登录，供业务调用
   *
   * @param {JSON} loginData
   * @returns {Promise}
   */
  login: function(loginData) {
    return new Promise((resolve, reject) => {
      handler.customLogin(loginData).then(res => {
        console.log("QQQQQQQQQQQQQQQQQQQQQQQQ START");
        console.log(res);
        if(res.code != 200) {
          Message.error(res.message);
        }
        console.log("QQQQQQQQQQQQQQQQQQQQQQQQ END");
        // 设置token
        setToken(res.data.token);
        // 必须设置登录状态
        setAuthed();
        resolve(res.data);
      }).catch(error => {
        console.log(error);
        reject(error)
      })
    })
  },

  /**
   * 获取条目信息
   *
   * @param {}
   * @returns {Promise}
   */
  getCatalogInfo: function(json) {
    return new Promise((resolve, reject) => {
      handler.getCatalogInfo(json).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 获取初始化数据
   *
   * @returns {Promise}
   */
  getInitData: function() {
    return handler.getInitData()
  },

  /**
   * 注销
   *
   * @param {boolean} redirectLogin   是否跳转到登录界面，默认跳转
   * @returns {Promise}
   */
  logout: function(data) {
    return new Promise((resolve, reject) => {
      handler.customLogout(data).then(() => {
        // 清空数据
        store.commit('user/CLEAR_INFO')
        store.commit('permission/CLEAR_PERMISSION')
        store.commit('tagsView/DEL_ALL_VISITED_VIEWS')
        store.commit('tagsView/DEL_ALL_CACHED_VIEWS')
        // 清空cookie
        removeAuthed()
        removeToken()
        localStorage.removeItem('userInfo')
        localStorage.removeItem('catalogId')
        localStorage.removeItem('user')
        localStorage.removeItem('menus')
        localStorage.removeItem('loginSupplier')
        localStorage.removeItem('isCustomUser')
        localStorage.setItem('sessionEpoch', Date.now())
        router.push(appConfig.loginPath)
        resolve()
      }).catch(error => reject(error))
    })
  },

  /**
   * 获取未读通知数
   *
   * @returns {Promise}
   */
  getUnreadMessage: function(userId) {
    return handler.getUnreadMessage(userId)
  },

  /**
   * 获取用户通知概要信息
   *
   * @returns {Promise}
   */
  getNotificationProfile: function(userId, data) {
    return handler.getNotificationProfile(userId, data)
  }
}
